module.exports = __webpack_public_path__ + "static/media/marque-miniparcours-sticker.73d4fce2.glb";